import { parsePared } from "../../../utils/horaDePared";
import moment from "moment";

export const isCampaignEditable = (campaign, timezone) => {
  const now = moment();

  // REGLA 1: INATIVA siempre editable
  if (campaign.status === "INATIVA") {
    return true;
  }

  // REGLA 2: EM_ANDAMENTO nunca editable
  if (campaign.status === "EM_ANDAMENTO") {
    return false;
  }

  // REGLA 2.1: FINALIZADA - ÚNICAS permiten ver en solo lectura
  if (campaign.status === "FINALIZADA") {
    return false;
  }

  // REGLA 3: CANCELADA siempre editable
  if (campaign.status === "CANCELADA") {
    return true;
  }

  // REGLA 4: PROGRAMADA - Validar tiempo mínimo (10 minutos)
  if (campaign.status === "PROGRAMADA") {
    // Para campañas recurrentes activas, validar nextScheduledAt
    const timeToCheck =
      campaign.isRecurring &&
      campaign.executionCount > 0 &&
      campaign.nextScheduledAt
        ? parsePared(campaign.nextScheduledAt, timezone)
        : parsePared(campaign.scheduledAt, timezone);

    if (!timeToCheck || !timeToCheck.isValid()) {
      return false;
    }

    const minutesUntilExecution = timeToCheck.diff(now, "minutes");
    return minutesUntilExecution > 10;
  }

  // Por defecto, no editable
  return false;
};

export const canOpenCampaignModal = (campaign, timezone) => {
  if (isCampaignEditable(campaign)) {
    return true;
  }

  // Permitir abrir modal en solo lectura para campañas ÚNICAS finalizadas
  if (campaign.status === "FINALIZADA" && !campaign.isRecurring) {
    return true;
  }

  return false;
};
